import { usePlanUnitsOptions } from 'hooks';

import { MultiSelect } from 'components/shared';
import {
  checkboxWidth,
  iconWidth,
  optionPadding
} from 'components/shared/Autocomplete/MuiAutocompleteOption';

import { useRenderOption } from './PlanUnitSelector/planUnitSelectorHooks';

export default function PlanUnitMultiSelect(props: any) {
  const { selectedOptions, showGroups = true, ...rest } = props;
  const options = usePlanUnitsOptions({ showGroups });

  const renderOption = useRenderOption({ isMulti: true });

  return (
    <MultiSelect
      {...rest}
      options={options}
      selectedOptions={selectedOptions}
      renderOption={renderOption}
      extraWidth={checkboxWidth + iconWidth + optionPadding}
    />
  );
}
